import React, { Component } from 'react';

import { sharedImageUrlAction } from '../actions.web';
import Input from "../../base/ui/components/web/Input";
import Dialog from "../../base/ui/components/web/Dialog";
import {translate} from "../../base/i18n/functions";
import {getFieldValue} from "../../base/react/functions";
import {connect} from "react-redux";


/**
 * Component that renders the video share dialog.
 *
 * @returns {React$Element<any>}
 */
class ImageOverlayDialog extends Component {

    /**
     * Instantiates a new component.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            okDisabled: true
        };

        this._onChange = this._onChange.bind(this);
        this._onSubmitValue = this._onSubmitValue.bind(this);
    }


    /**
     * Callback for the onChange event of the field.
     *
     * @param {Object} evt - The static event.
     * @returns {void}
     */
    _onChange(evt) {
        const linkValue = getFieldValue(evt);

        this.setState({
            value: linkValue,
            okDisabled: !linkValue
        });
    }


    /**
     * Callback to be invoked when the value of the link input is submitted.
     *
     * @returns {boolean}
     */
    _onSubmitValue() {
        // eslint-disable-next-line react/prop-types
        this.props.conference.setLocalParticipantProperty('set_shared_image', this.state.value);

        return APP.store.dispatch(sharedImageUrlAction(this.state.value));
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const { t } = this.props;

        return (
            <Dialog
                hideCancelButton = { false }
                okDisabled = { this.state.okDisabled }
                okKey = { t('dialog.Share') }
                onSubmit = { this._onSubmitValue }
                titleKey = 'Share Image'
                width = { 'small' }>
                <Input
                    autoFocus = { true }
                    className = 'input-control'
                    compact = { false }
                    label = { 'Image Link' }
                    name = 'sharedImageUrl'
                    onChange = { this._onChange }
                    shouldFitContainer = { true }
                    type = 'text'
                    value = { this.state.value } />
            </Dialog>
        );
    }

}

// eslint-disable-next-line require-jsdoc
function _mapStateToProps(state) {
    const conference = state['features/base/conference'].conference;

    return {
        conference
    };
}

export default translate(connect(_mapStateToProps)(ImageOverlayDialog));
